const heading1Numbered = [
  "M5.9 15.41l.96-3.57h2.42l-.95 3.57h1.82l.95-3.57h3.33l.47-1.75h-3.34l.64-2.33h3.32L16 6.01h-3.34l.9-3.3h-1.82L10.86 6H8.42l.9-3.3H7.5L6.6 6H3.27L2.8 7.76h3.34l-.62 2.33H2.18l-.46 1.75h3.34l-.97 3.57zm3.86-5.32H7.34l.62-2.33h2.42zM.72 4.4V2.83h1.7V4.4h.73V.6h-.72v1.56H.73V.6H0V4.4zm4.57 0V.6h-.73L3.84 1v.8l.72-.44V4.4z"
];
export {
  heading1Numbered
};
//# sourceMappingURL=heading1Numbered.js.map
